import { get as fetch } from '../utils/fetch.util'

export const get = () => fetch('/v1/regions?sort=bylocation')
